import * as React from 'react';
import { Markdown } from '../../../extra/Markdown';
import Theme from '../../../theme';
export var DescriptionField = function (_a) {
    var id = _a.id, description = _a.description;
    if (!description) {
        return null;
    }
    return (React.createElement(Markdown, { mb: 1, id: id, className: "rendition-form-description", color: Theme.colors.text.light, fontSize: 1 }, description));
};
